import React from "react";
import { Grid, Skeleton } from "@mui/material";

interface CompactTextLinesSkeletonProps {
  lines?: number;
}

const CompactTextLinesSkeleton: React.FC<CompactTextLinesSkeletonProps> = ({ lines = 3 }) => {
  return (
    <Grid container direction="column" rowGap={0.5}>
      {Array.from({ length: lines }, (_, index) => (
        <Grid item key={`compact-text-skeleton-line-${index}`}>
          <Skeleton variant="rounded" width={"50%"} height={20} />
        </Grid>
      ))}
    </Grid>
  );
};

export default CompactTextLinesSkeleton;